import axios from "axios";
import cutehub from "../../router/cutehub";
import country_list from "../../locales/country_list.json";
import $ from "jquery";

const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();

const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 

let brwlang = localStorage.getItem("lang_cutehub");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = ''

if (type == true) {
    gcid = parts[1]
} else {
    gcid = ''
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_cutehub: {},
  //auth
  auth_cutehub: "",
  //main.vue
  //hotpicks.vue
  pageHP_cutehub: {},
  //popular.vue
  pagePop_cutehub: {},
  //notification.vue
  notification_cutehub: {},
  //icon
  hotpickIcon_cutehub: require(`../../assets/cutehub/imgs/other/Hot Picks.svg`),
  popularIcon_cutehub: require(`../../assets/cutehub/imgs/other/Populars.svg`),
  langButton_cutehub: ``,
  country_cutehub: parts[0],
  host_cutehub: host,
  // lang_cutehub: localStorage.getItem("lang_cutehub"),
  lang_cutehub: brwlang,
  type: 'browse',
  gcid_cutehub: gcid,
  hpisLoad_cutehub: false,
  renew_date_cutehub: '',
  subscription_date_cutehub: '',
  msisdn_cutehub: '',
  country_code_cutehub: '',
  gateway_code_cutehub: '',
  is_unsub: '0',
};

const getters = {
  langButton_cutehub: state => state.langButton_cutehub,
  lang_cutehub: state => state.lang_cutehub,
  gcid_cutehub: state => state.gcid_cutehub,
  country_cutehub: state => state.country_cutehub,
  allSubcategory_cutehub: state => state.allsubcategory_cutehub,
  pageHotPicks_cutehub: state => state.pageHP_cutehub,
  pagePopular_cutehub: state => state.pagePop_cutehub,
  HotPickIcon_cutehub: state => state.hotpickIcon_cutehub,
  PopularIcon_cutehub: state => state.popularIcon_cutehub,
  notification_cutehub: state => state.notification_cutehub,
  host_cutehub: state => state.host_cutehub,
  auth_cutehub: state => state.auth_cutehub,
  hpisLoad_cutehub: state => state.hpisLoad_cutehub,
  renew_date_cutehub: state => state.renew_date_cutehub,
  subscription_date_cutehub: state => state.subscription_date_cutehub,
  msisdn_cutehub: state => state.msisdn_cutehub,
  country_code_cutehub: state => state.country_code_cutehub,
  gateway_code_cutehub: state => state.gateway_code_cutehub,
  is_unsub_cutehub: state => state.is_unsub,
};

const actions = {
  async fetchLocale_cutehub({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchTranslateButton_cutehub({commit}, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_cutehub({commit}, subcategory){
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );
    
    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchPageHotPicks_cutehub({ commit }, file) {
    let data = file[0]

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(file[1].target.options[file[1].target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = []

    if(data == undefined){
      response = await axios.get(
        `${state.live}/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
      );
    }else{
      response = await axios.get(
        `${state.live}/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a,b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    )

    // console.log(response.data.data);

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_cutehub({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = await axios.get(
      `${state.live}/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
    );

    response.data.data.sort((a,b) =>
      // a.content_name.localeCompare(b.content_name),
      b.rating - a.rating
    )

    commit("setPagePopular", response.data.data);
  },
  async fetchToken_cutehub({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_cutehub");
    let userProfile = localStorage.getItem("userProfile_cutehub");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join('/');

    if(path == ''){
      path = '/home';
    }
    
    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }
    
    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_cutehub", auth);
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      cutehub.push({ name: "Login" }).catch(err => {});
    }
    
    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        if(data.code == 'chub80'){
          localStorage.setItem("userToken_cutehub", data.code);
          commit("setAuth", "guest");
        }else{
          localStorage.setItem("userToken_cutehub", data.code);
          commit("setUserProfile", JSON.parse(userProfile));
          commit("setAuth", "loggedin");
        }
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        if(data.code == 'chub80'){
          localStorage.setItem("userToken_cutehub", data.code);
          commit("setAuth", "guest");
        }else{
          let responses = await axios.post(
            `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
           
          );
          
          var response = JSON.parse(responses.data.contents);
          
          if (response.status == "active") {
            localStorage.setItem("userToken_cutehub", data.code);
            localStorage.setItem("userProfile_cutehub", responses.data.contents)
            commit("setUserProfile", response);
            commit("setAuth", "loggedin");
            cutehub.push({ path: path }).catch(err => {});
            // location.reload();
          } else if (response.status == "inactive") {
            if(data.code != undefined){
              alert(response.status.toUpperCase())
            }
            cutehub.push({ name: "Login" }).catch(err => {});
          }
        }
      }
    } else {
      //if check is false
      cutehub.push({ name: "Login" }).catch(err => {});
    }
  },
  async getDomain_cutehub({ commit }, host){
    let response = await axios.get(`${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`);

    let dom= response.data.data
    dom = dom.filter(item =>{
      return item.domain == host;
    })

    let domain = ""

    if(dom != ""){
      domain = dom[0].is_unsub;

      if(dom[0].gateway_id != '0') commit('setGatewayID', dom[0].gateway_id)
    }else{
      domain = '0'
    }
    commit("setUnsubButton", domain);
  },
  async checkToken_cutehub({ commit }, auth) {
    var letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_cutehub({ commit }, file) {
    let token = localStorage.getItem("userToken_cutehub");
    let lang = localStorage.getItem("lang_cutehub");
    let alert_pop = "";
    
    let alert_lang = require(`../../locales/cutehub/${lang}.json`);
    alert_pop = alert_lang.not_subs;
    if(state.auth_cutehub == 'guest'){
      commit("setAuth", "");
      localStorage.removeItem("userToken_cutehub");
      cutehub.push({ name: "Login" }).catch(err => {});
    }else{
      if (token != null) {
        if (file[1] != 'application/x-zip-compressed') {
          axios.post(`${state.live}/api/newcontents_statistic`, {
            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
            country: state.country_cutehub,
            product: 'cutehub',
            content_id: file[2],
            type: "download"
          })
          window.location.href = file[0];
          // window.open(file[0], "download");
        } else {
          axios.post(`${state.live}/api/newcontents_statistic`, {
            token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
            country: state.country_cutehub,
            product: 'cutehub',
            content_id: file[2],
            type: "play"
          })

          window.open(file[0], "_blank");
        }
      } else {
        alert(alert_pop);

        setTimeout(() => {
          cutehub.push({ name: "Login" }).catch(err => {});
        }, 1000);
      }
    }
  },
  async login_cutehub({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_cutehub({ commit }) {
    let notify =[]
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if(w != 0){
      date = date + 10
    }
    
    let res = await axios.get(
      `${state.live}/api/contents/cutemobi_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=${host}`
    );
    let data = res.data.data;
    let noti = data.map((noti) =>{
      noti.titleSub_english = noti.subcategory
      if(noti.subcategory_translate != null){
        let sub_trans = JSON.parse(noti.subcategory_translate)
        if(sub_trans != null){
          let trans_len = Object.keys(sub_trans).length
          let trans_arr = Object.keys(sub_trans)
          
          if(sub_trans != null || sub_icon != null){
            for(let i = 0; i<trans_len; i++){
                noti['titleSub_'+trans_arr[i]] = sub_trans[trans_arr[i]].title
            }
          }
        }
      }
      return noti;
    })

    // if(w == 0){
    //   //name ascending
    //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
    // }else{
    //   //name descending
    //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
    // }

    notify = noti.slice(5,10);

    commit("setNotification", notify);
  },
  async logout_cutehub({commit}, is_unsub){
    if(is_unsub != '0'){
      let token = localStorage.getItem("userToken_cutehub")
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_code_cutehub}/${state.gateway_code_cutehub}/unsub.php?code=${token}&msisdn=${state.msisdn_cutehub}`));
      removeStorage()
      var response = JSON.parse(responses.data.contents);
      console.log(responses.data)
      $("#exampleModalCenter").modal("hide");
      if(responses.data.contents== 'success' || response.status =='success'){
        if (state.country_cutehub == 'iq') {
          cutehub.push({ name: 'Unsubscription'}).catch(err => {});
        } else {
          cutehub.push({ name: 'Login'}).catch(err => {});
        }
      }
    }else{
      removeStorage();
      if (state.country_cutehub == 'iq') {
        $("#exampleModalCenter").modal("hide");
        cutehub.push({ name: 'Unsubscription'}).catch(err => {});
      } else {
        cutehub.push({ name: 'Login'}).catch(err => {});
      }
    }

    function removeStorage(){
      localStorage.removeItem("userProfile_cutehub");
      localStorage.removeItem("userToken_cutehub");
      localStorage.removeItem("logged-in");
      commit("setAuth", "");
    } 
    
  }
};

const mutations = {
  setPageHotPicks: (state, response) => (state.pageHP_cutehub = response),
  setPagePopular: (state, response) => (state.pagePop_cutehub = response),
  setNotification: (state, response) => (state.notification_cutehub = response),
  setAuth: (state, response) => (state.auth_cutehub = response),
  setButton: (state, response) => (state.langButton_cutehub = response),
  setLanguage: (state, response) => (state.lang_cutehub = response),
  setAllSubcategory: (state, response) => (state.allsubcategory_cutehub = response),
  setUserProfile: (state, response) => (
    state.renew_date_cutehub = response.next_renew_date,
    state.subscription_date_cutehub = response.subscription_date,
    state.msisdn_cutehub = response.msisdn,
    state.country_code_cutehub = response.country_code,
    state.gateway_code_cutehub = response.gateway_code
  ),
  setGatewayID: (state, response) =>(
    state.gcid_cutehub = response
  ),
  setUnsubButton: (state, response) => (
    state.is_unsub = response
  )
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cutehub-store.js